import { resolveLocalizedField } from '@/shared/localizedField/LocalizedFieldDisplay'
import { readStoredLocalizedText, type StoredLocalizedText } from '@/shared/localizedField/localizedDraft'

export type PublishedLocalizedText = StoredLocalizedText

export function readPublishedLocalizedText(raw: unknown, maxLength: number, optional = false): PublishedLocalizedText | null {
  const value = readStoredLocalizedText(raw, { required: !optional, maxLanguages: 32, maxLength })
  if (!optional && value === null) throw new Error('published localized text is required')
  return value
}

export function publishedText(value: PublishedLocalizedText | null, language: string, fallback = ''): string {
  return resolveLocalizedField(value, language, fallback).text ?? fallback
}
